var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBubbleTailBot = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 39.0587,
    height: 30.9788,
    viewBox: "0 0 39.0587 30.9788",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "box-angle",
    d: "M0 3C0 1.34315 1.34315 0 3 0H36.0529C38.9306 0 40.1574 3.65886 37.8614 5.3936L4.8085 30.3669C2.83215 31.8602 0 30.4503 0 27.9733V3Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBubbleTailBot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bubble-tail-bot.1f9bb80b1a19d388f60020940136d140.svg";